'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
/* injects from baggage-loader */

/* eslint no-console: 0 */


var debug = require('debug')('metapro:logger');

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var type = action.type;

      var rest = _objectWithoutProperties(action, ['type']);

      if (type && type.substring(0, 2) !== '@@' && type.substring(0, 7) !== 'EFFECT_') {
        if (console.group) {
          console.group(type);
          if (!_lodash2.default.isEmpty(rest)) {
            console.info('payload', rest);
          }
        } else {
          debug(type);
        }
      }
      var result = next(action);
      if (type && type.substring(0, 2) !== '@@' && type.substring(0, 7) !== 'EFFECT_') {
        if (console.groupEnd) {
          console.info('next state', store.getState());
          console.groupEnd(type);
        }
      }
      return result;
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./app/store/logger.js
// module id = 640
// module chunks = 1